// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"UpsellProductBrandRefresh_carouselWrapper__1aT2B"};